let mapView = false;
(function ($, Drupal) {
  Drupal.behaviors.propertyToggleBehavior = {
    attach(context, settings) {
      // Variables
      const toggleListBtn = document.getElementById('property-toggle-list');
      const toggleListView = document.getElementById('property-list-view');
      const toggleMapBtn = document.getElementById('property-toggle-map');
      const toggleMapView = document.getElementById('property-map-view');
      const toggleTopView = document.getElementById('property-top');
      const propertyListing = document.querySelector('.property-listing');

      // List and Map Toggle
      function setPropertyToogle(activeBtn, activeView, inactiveBtn, inactiveView) {
        mapView = false;
        if (activeView.id === 'property-map-view') {
          mapView = true;
        }
        activeBtn.setAttribute('aria-expanded', 'true');
        inactiveBtn.setAttribute('aria-expanded', 'false');
        activeBtn.classList.add('usa-button--base');
        activeBtn.classList.remove('usa-button--outline');
        inactiveBtn.classList.add('usa-button--outline');
        inactiveBtn.classList.remove('usa-button--base');
        inactiveView.hidden = true;
        activeView.hidden = false;
        if (activeView === toggleMapView) {
          toggleTopView.classList.add('property-listing__results--map');
        } else {
          toggleTopView.classList.remove('property-listing__results--map');
        }
      }

      function setPropertyMobile() {
        if (window.innerWidth < 880) {
          toggleMapView.hidden = true;
          toggleListView.hidden = false;
          toggleMapBtn.setAttribute('aria-expanded', 'false');
          toggleMapBtn.classList.remove('usa-button--base');
          toggleMapBtn.classList.add('usa-button--outline');
          toggleListBtn.setAttribute('aria-expanded', 'true');
          toggleListBtn.classList.remove('usa-button--outline');
          toggleListBtn.classList.add('usa-button--base');
          toggleTopView.classList.remove('property-listing__results--map');
        }
      }

      function getVisibleHeight(element) {
        const rect = element.getBoundingClientRect();
        const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        return Math.max(0, Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0));
      }

      function updateVisibleHeight() {
        const siteHeader = document.querySelector('.usa-header');
        const filterTotal = document.querySelector('.property-listing__filter-total');
        const filterActions = document.querySelector('.property-filters__actions');
        const filterItems = document.querySelector('.property-filters__items');
        const topHeight = getVisibleHeight(filterTotal);
        const actionsHeight = filterActions.offsetHeight;
        let headerHeight = 0;

        if (siteHeader) {
          headerHeight = getVisibleHeight(siteHeader);
        }

        if (window.innerWidth >= 880) {
          filterItems.style.maxHeight = `calc(100vh - ${topHeight}px - ${actionsHeight}px - ${headerHeight}px)`;
        } else {
          filterItems.style.maxHeight = 'auto';
        }
      }

      const onScroll = () => {
        const rect = toggleListView.getBoundingClientRect();
        if (rect.top <= 0) {
          propertyListing.classList.add('property-listing--scrolled');
        } else {
          propertyListing.classList.remove('property-listing--scrolled');
        }
      };

      const callback = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            window.addEventListener('scroll', onScroll);
          } else {
            window.removeEventListener('scroll', onScroll);
            propertyListing.classList.remove('property-listing--scrolled');
          }
        });
      };

      const observer = new IntersectionObserver(callback, {
        root: null,
        threshold: 0,
      });

      if (propertyListing) {
        if (mapView === true) {
          setPropertyToogle(toggleMapBtn, toggleMapView, toggleListBtn, toggleListView);
        }
        $(toggleListBtn).on('click', () => {
          setPropertyToogle(toggleListBtn, toggleListView, toggleMapBtn, toggleMapView);
        });

        $(toggleMapBtn).on('click', () => {
          setPropertyToogle(toggleMapBtn, toggleMapView, toggleListBtn, toggleListView);
        });

        $(window).on('resize', setPropertyMobile);
        updateVisibleHeight();

        $(window).on('scroll', () => {
          let scrollTimeout;
          updateVisibleHeight();

          if (window.scrollY === 0) {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(updateVisibleHeight, 255);
          }
        });

        $(window).on('resize', updateVisibleHeight);
        observer.observe(toggleListView);
      }
    },
  };
})(jQuery, Drupal);
